import React, { useState, useEffect } from "react";
import Pending from "../../../assets/Icon/pending.png";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const QnaPending = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);
  const [buffer, setBuffer] = useState(true);
  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/admin/pending/qna`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title="Pending QnA Events" image={Pending} count={count} />
      {buffer ? (
        <LoaderPost />
      ) : (
        <>
          <AllModuleData
            data={event_data}
            urlLink={`/superstar-admin/qna/details`}
            qna={"true"}
          />
        </>
      )}
    </>
  );
};

export default QnaPending;
